import { ConfigType } from "../utils/requestAPI";

export type paginationType = {
  limit?: number;
  total?: number;
  isRead?: boolean | null;
  totalPages?: number;
  currentPage?: number;
  page?: number;
  search?: string;
  resourceId?: string;
  notifiedTo?: string;
  type?: string;
};
const notification = {
  getNotifications: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "/notifications",
      params,
    };
  },
  markasRead: ({
    notificationId,
  }: // params,
  {
    notificationId: string[];
    params?: paginationType;
  }): ConfigType => {
    return {
      method: "patch",
      url: "/notifications/mark-as-read",
      data: { notificationIds: notificationId },
      // params,
    };
  },
};
export default notification;
